export interface FiltersPatientCases {
    searchText: string | null;
    entryDateFrom: moment.Moment | null;
    exitDateTo: moment.Moment | null;
    environmentID: number | null;
}


export type PatientCasesFiltersDispatch =
    { type: 'CHANGE_TEXT', text: string } |
    { type: 'CHANGE_ENTRY_DATE', date: moment.Moment | null } |
    { type: 'CHANGE_EXIT_DATE', date: moment.Moment | null } |
    { type: 'CHANGE_ENVIRONMENT_ID', environmentID: number | null };

export const patientCasesFiltersReducer = (state: FiltersPatientCases, action: PatientCasesFiltersDispatch): FiltersPatientCases => {

    if (action.type === 'CHANGE_TEXT') {
        const text = action.text.trim() === '' ? null : action.text;
        return { ...state, searchText: text };
    }

    if (action.type === 'CHANGE_ENTRY_DATE') {
        return { ...state, entryDateFrom: action.date };    
    }

    if (action.type === 'CHANGE_EXIT_DATE') {
        return { ...state, exitDateTo: action.date };    
    }

    if (action.type === 'CHANGE_ENVIRONMENT_ID') {
        return { ...state, environmentID: action.environmentID };
    }

    return state;

}